export const environment = {
  production: true,
  ENVIRONMENT: 'develop',
  AUTH0_DOMAIN: 'lad-dev.auth0.com', //"lad-dev.auth0.com",
  AUTH0_CLIENTID: 'zMLFMDUNHqgRpCQLIAmJhnNr3YtveRNw', //"zMLFMDUNHqgRpCQLIAmJhnNr3YtveRNw",
  AUTH0_REALM: 'Affiliates-Username-Password-Authentication', // 'Affiliates-Username-Password-Authentication',
  AUTH0_SCOPE: 'openid offline_access', //'openid offline_access',
  IDENTITY_PLATFORM: {
    apiKey: 'AIzaSyBpqlXuCZ6ngegcv1vZpWRdSFUb26nKHbM',
    authDomain: 'llamando-al-doctor.firebaseapp.com',
    projectId: 'llamando-al-doctor',
    appId: '1:633188037654:web:fe500c454c0ab7301eb137',
    tenantId: 'lad-patients-dev-36fuu',
    authEmulatorUrl: ''
  },
  API_URL: 'https://dev.api.llamandoaldoctor.com', //'https://dev.api.llamandoaldoctor.com'
  PWA_URL: 'https://dev.app.llamandoaldoctor.com', //'https://dev.app.llamandoaldoctor.com',
  BASE_WS_URL: 'wss://dev.psocket.llamandoaldoctor.com:8084', //'wss://dev.api.llamandoaldoctor.com:8084/',
  BASE_WS_TRANSLATOR_URL: 'wss://dev.tsocket.llamandoaldoctor.com:8085',
  BITBUCKET_BUILD_NUMBER: '1366',
  OPENTOK_API_KEY: '45772292', // 45772292
  callConfig: {
    DEFAULT_CALL_TIMEOUT_MS: 420000, //7 minutos
    MIN_MS_FOR_VALID_CALL: 180000 //3 minutos
  },
  FAQ_URL: 'https://llamandoaldoctor.com/paciente.html#faqs-paciente',
  LAD_CONTACT_EMAIL: 'contacto@llamandoaldoctor.com', // contacto@llamandoaldoctor.com
  ANALYTICS_ID: 'UA-88686723-3',
  PS_AUTH0_CONNECTION: 'ps-sancor-dev',
  IOS_APP_STORE: 'itms-apps://itunes.apple.com/in/app/llamando-al-doctor/id1196903602',
  ANDROID_APP_STORE: 'market://details?id=com.llamandoaldoctor',
  ROLLBAR_CONFIG: {
    ROLLBAR_ACCESS_TOKEN: 'dce2f36d801f4e329710cdf497a9533e',
    ROLLBAR_ENVIRONMENT: 'development'
  },
  COOKIE_FIRST_KEY: '59a6419c-17bd-496e-a04d-bb66f28e212a',
  SPECIALTIES: {
    PEDIATRICS: '58e2590da78b4010008c4972'
  },
  GOOGLE_MAPS_API_KEY: 'AIzaSyAf7QIw6FPWizFuMxX-qmhZ3_9RqeFUMoc',
  GOOGLE_PLACES_API_KEY: 'AIzaSyAZVJMHE3Kylf_ElsDqZDhtmnFhDwPa9FA'
};
